export default "__VITE_ASSET__CXuCc6L9__"